// merchant.js
export const FETCH_MERCHANT = 'FETCH_MERCHANT'
export const RESET_MERCHANT = 'RESET_MERCHANT'
export const FETCH_MERCHANT_SUCCESS = 'FETCH_MERCHANT_SUCCESS'
export const FETCH_MERCHANT_FAILURE = 'FETCH_MERCHANT_FAILURE'
export const FETCH_MERCHANTS = 'FETCH_MERCHANTS'
export const RESET_MERCHANTS = 'RESET_MERCHANTS'
export const FETCH_MERCHANTS_SUCCESS = 'FETCH_MERCHANTS_SUCCESS'
export const FETCH_MERCHANTS_FAILURE = 'FETCH_MERCHANTS_FAILURE'
export const SET_LANGUAGE = 'SET_LANGUAGE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js